import React, { useEffect } from "react";
import { useFormikContext } from "formik";
import Text from "components/atoms/Text";
import CheckboxField from "components/molecules/CheckboxField";
import { Space } from "antd";
import { networkOptions } from "../utils/options";
import TableFieldExternalPagination from "components/molecules/TableFieldExternalPagination";
import DateField from "components/molecules/DateField";
import TableMenu from "components/molecules/TableMenu";
import { autoFillOutOfNetworkCoverage } from "../utils/table";
import { useLocation } from "react-router-dom";

const columns = (planOptions) =>
  [
    {
      title: "",
      dataIndex: "idx",
      width: 22.5,
      editable: false,
      fixed: "left",
    },
    {
      title: "Pharmacy Benefit Manager Name",
      dataIndex: "name",
      width: 200,
      editable: true,
      inputType: "text",
      shouldCellUpdate: () => false,
    },
    {
      title: "Plans Under Management",
      dataIndex: "planList",
      width: 200,
      editable: true,
      isMultiSelect: true,
      inputType: "select",
      dropdownMatchSelectWidth: 350,
      options: planOptions,
      shouldCellUpdate: () => false,
    },
    {
      title: "",
      key: "operation",
      fixed: "right",
      width: 48,
      render: (_, record) => <TableMenu record={record} />,
    },
  ].map((col) => {
    return {
      ...col,
      onCell: (_, idx) => ({
        index: idx,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        inputType: col.inputType,
        options: col.options,
        dropdownMatchSelectWidth: col.dropdownMatchSelectWidth,
        disabled: col.disabled || false,
        isMultiSelect: col.isMultiSelect || false,
        emptyValue: col.emptyValue,
      }),
    };
  });

const handleAddButton = (table, setFieldValue, tableName) => {
  const nextIndex = table.length !== 0 ? Math.max(...table.map((element) => element.idx)) + 1 : 1;
  const obj = {
    idx: Math.floor(nextIndex),
    tableName: tableName,
  };
  table.push(obj);
  setFieldValue(tableName, [...table]);
};

const Step = () => {
  const { state } = useLocation();
  const { values, setErrors, setTouched, setFieldValue } = useFormikContext();
  const { table, pharmacyManagersTable } = values;
  const plansSelected = pharmacyManagersTable.map((item) => item.planList).flat();
  const planOptions = table
    .map((plan) => plan.label)
    .filter((value) => !plansSelected.includes(value))
    .map((value) => ({
      name: value,
      value: value,
    }));

  useEffect(() => {
    document.getElementById("form-content").scrollTo({ top: 0, behavior: "smooth" });
    setErrors({});
    setTouched({}, false);
  }, []);

  return (
    <>
      <Text sectionTitle>Pharmacy Benefit Managers</Text>
      <Space direction="vertical" size="middle" style={{ display: "flex" }}>
        <TableFieldExternalPagination
          name="pharmacyManagersTable"
          columns={columns(planOptions)}
          dataSource={pharmacyManagersTable}
          pageSize={10}
          tableLayout="fixed"
          handleAddButton={() => handleAddButton(pharmacyManagersTable, setFieldValue, "pharmacyManagersTable")}
        />
      </Space>
    </>
  );
};

export default Step;
